import React from 'react';

function formatDate(date) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  return `${day} ${months[monthIndex]}, ${year}`;
}

const today = new Date();

function ExitLetter(props) {
  const { Name, id, resignation, exit, doj, designation,last } = props?.data || {};

  return (
    <div style={{ height: 'calc(100% - 64px)', overflowY: 'auto' }}>
      <div className='container'>
        <div style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '16px', lineHeight: 1.35, padding: '40px', color: '#333', backgroundColor: 'white' }}>
          <p style={{ textAlign: 'right', marginBottom: '20px' }}>{formatDate(today)}</p>

          <p><strong>To</strong></p>
          <p><strong>{Name}</strong></p>
          <p><strong>{id}</strong></p>

          <p style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px', margin: '20px 0' }}>Relieving Letter</p>

          <p>Dear {Name},</p>

          <p>
            This is with reference to your letter of resignation dated <strong>{formatDate(new Date(exit))}</strong>, 
            requesting to be relieved from your services with us on or before <strong>{formatDate(new Date(last))}</strong>. 
            Your resignation has been accepted, and you are relieved from your duties and responsibilities by the close of 
            business hours on <strong>{formatDate(new Date(last))}</strong>.
          </p>

          <p>Your service record with the company is as follows:</p>

          <p>
            <strong>Date of Joining:</strong> {formatDate(new Date(doj))} <br/>

            <strong>Last Designation:</strong> {designation}<br/>

            <strong>Last Working Date:</strong> {formatDate(new Date(last))}
          </p>

          <p>Thank you for your contributions. We wish you the very best in your future endeavors.</p>

          <div style={{ marginTop: '40px' }}>
            <p><strong>Yours sincerely,</strong></p>
                <p style={{ margin: 0, }}>
                  Venkata Rangarajan
              </p>

              <p style={{ margin: '4px 0 0' }}>
                  Director and Head of India Operations
              </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExitLetter;